import React from 'react';
import { InteractionComponent } from '@/components/DesignSystem/AtomicComponents/CartButton/CartButton.styles';
import { PlusIcon } from '@/assets/svgExports/PlusIcon';

function RightCartButton(props) {
  const { handleCart, disabledAdditionComponent, isPDPPage } = props;
  return (
    <InteractionComponent
      position="right:14px;"
      width="30px"
      isPDPPage={isPDPPage}
      onClick={(e) => {
        e.stopPropagation();
        handleCart('inc');
      }}
    >
      <span className={disabledAdditionComponent() ? 'o-100' : 'o-20'}>
        <PlusIcon iconWidth={props?.iconWidth} />
      </span>
    </InteractionComponent>
  );
}

export default RightCartButton;
